import Modal from 'react-modal'
import {Login} from 'components/forms/login/login'
import { ReactComponent as Clean } from './clean.svg'
import { useEffect, useRef, useState } from 'react';

Modal.setAppElement('#root');

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 13000,
        backgroundColor: '#E7F2FE',
        boxShadow: '8px 8px 35px rgba(0, 0, 0, 0.15)',
        padding: null,
        borderRadius: '15px',
        border: 0,
        maxWidth: null,
        // width: '100%',
    },
};

export const FormModal = ({
    isOpen,
    setIsOpen
}) => {
    const modalRef = useRef()
    const closed = () => setIsOpen(false)
    const [step, setStep] = useState(0)
    useEffect(()=> {
        if (step === 2) {
            modalRef.current.portal.content?.classList.add('modal-2')
        } else {
            modalRef.current.portal.content?.classList.remove('modal-2')
        }
    }, [step, modalRef])
    return (
        <Modal
            ref={modalRef}
            isOpen={isOpen}
            style={customStyles}
            contentLabel="Анкета"
        >
            <div className={["modal-wrap", step === 2 ? 'modal-page-2' : ''].join(' ')}>
                <button className="closed" onClick={closed}>
                    <Clean />
                </button>
                <Login closed={closed} setStep={step => setStep(step)} />
            </div>
        </Modal>
    )
}
